import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { SessionService } from "../../services/session.service";

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get token from the correct localStorage key (ngrx-store-localstorage stores entire auth object)
    let token: string | null = null;

    try {
      const authState = localStorage.getItem('auth');
      if (authState) {
        const parsedAuthState = JSON.parse(authState);
        token = parsedAuthState.token || null;
      }
    } catch (error) {
      console.error('[HeadersInterceptor] Error parsing auth state from localStorage:', error);
      token = null;
    }

    let headers = req.headers
      .set("Accept", "application/json")
      // New UI migration: lets the API track activity per UI.
      .set("X-Client-UI", "legacy");

    // Don't set Content-Type for FormData — the browser sets it automatically with the boundary
    if (!(req.body instanceof FormData)) {
      headers = headers.set("Content-Type", "application/json");
    }

    // Only set Authorization header when we have a token
    if (token) {
      headers = headers.set("Authorization", `Bearer ${token}`);
    }

    const clone = req.clone({ headers });

    return next.handle(clone).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Skip 401 handling for auth endpoints to avoid loops
          const url = req.url;
          const isAuthEndpoint =
            url.includes('/login') || url.includes('/register') || url.includes('/logout');

          // Only a genuine session-auth failure should sign the user out. Laravel Sanctum
          // returns exactly {"message":"Unauthenticated."} for that case. A 401 that is
          // proxied from a downstream provider (e.g. Veridion) uses our ApiErrorResponse
          // shape and must NOT log the user out.
          const isSessionExpired = error.error?.message === 'Unauthenticated.';

          if (!isAuthEndpoint && isSessionExpired) {
            // Use injector to lazily resolve SessionService (avoids circular DI)
            const sessionService = this.injector.get(SessionService);
            sessionService.signOut();
          }
        }
        return throwError(() => error);
      })
    );
  }
}
